






























import { Component, Prop, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { DataModules } from "@/store/modules/data";
import { ITaxBusinessType } from "@/models/tax";
import TaxBusinessTypesTable from "@/components/app/global/tax/taxBusinessTypesTable.vue";
import { ValidationObserver } from "vee-validate/dist/types/components/Observer.d";

@Component({
  components: {
    TaxBusinessTypesTable
  }
})
export default class ManageTaxBusinessTypeModal extends Mixins(HasValidation) {
  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    taxBusinessTypesTable: TaxBusinessTypesTable;
  };
  // Props
  @Prop({ default: () => [] })
  public readonly selectedBusinessType!: ITaxBusinessType[];

  // Data
  public dataModule = DataModules.TAX_TEMPLATES;
  public isProcessing = false;
  public selected: ITaxBusinessType[] = this.selectedBusinessType;

  // Methods
  public update() {
    this.$emit("select", this.selected);
    this.$emit("close");
  }
}
